<template>
    <div class="customer-search">
        <div class="search-group">
            <input 
                type="text" 
                v-model="text" 
                placeholder="Customer" 
                @keyup.prevent="searchKeyup" 
                class="customer-search-input form-control"
            >
            <i 
                class="fa fa-times search-clear" 
                @click="clear(true)"
            />
        </div>
        <div 
            class="results-container" 
            v-if="results.length && showResults"
        >
            <ul class="results">
                <li 
                    v-for="(c, index) of results" 
                    :key="c.id"
                >
                    <a 
                        href="#" 
                        @click.prevent="makeSelection(index)" 
                        :class="{focussed : index === selectedIndex}"
                    >{{ c.company_name }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import CustomerService from "../services/CustomerService";

export default {
    name: "CustomerSearch",
    props: {
        customer: {
            type: Object,
            default: () => {
                return {
                    company_name: '',
                }
            }
        },
        customerId: {
            default: () => null,
        }
    },
    data: function () {
        return {
            text: "",
            results: [],
            showResults: false,
            selectedIndex: null
        };
    },

    watch: {
        customer: function (val) {
            if (val && val.company_name) {
                this.text = val.company_name;
            } else {
                this.text = "";
            }
        },
        customerId: function () {
            this.loadFromID();
        }
    },

    mounted: function () {
        if (this.customer !== null && this.customer.company_name) {
            this.text = this.customer.company_name;
        }

        this.loadFromID();
    },

    methods: {
        searchKeyup: function () {
            this.showResults = false;
            if (this.text.length === 0) {
                this.clear();
            }
            if (this.text.length > 2) {
                setTimeout(this.search, 250);
            }
        },

        clear: function (emit = false) {
            if (emit) {
                this.$emit("change", null);
            }
            this.text = "";
            this.selectedIndex = null;
            this.showResults = false;
            this.results = [];
        },

        makeSelection: function (index) {
            this.$emit("change", this.results[index]);
            this.text = this.results[index].company_name;
            this.showResults = false;
        },

        search: function () {
            CustomerService.search({
                "filter[keyword]": this.text,
                include: ["sites", "sites.address"]
            }).then(
                res => {
                    this.results = res.data.data;
                    this.showResults = true;
                },
                () => {
                    alert("Error: Failed to load customers");
                }
            );
        },
            
        loadFromID: function () {
            if (this.customerId === null) {
                return;
            }

            CustomerService.get(this.customerId).then(res => {
                this.results = [res.data];
                this.makeSelection(0);
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CustomerSearch.vue